<template>
    <div class="surfing_banner_outer position-relative">
        <header class="header">
            <div class="container">
                <nav class="navbar navbar-expand-lg navbar-light p-0">
                    <router-link :to="{ name: localizedRouteName('Home') }" class="navbar-brand">
                        <figure class="logo mb-0"><img src="/src/assets/logos/enigma-fishing-logo-words-black.png"
                                alt="Enigma Charter Mallorga logo" class="img-fluid"></figure>
                    </router-link>
                    <button class="navbar-toggler collapsed" type="button" data-toggle="collapse"
                        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                        <span class="navbar-toggler-icon"></span>
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav">
                            <li class="nav-item" :class="{ active: $route.name === localizedRouteName('Home') }">
                                <router-link class="nav-link" :to="{ name: localizedRouteName('Home') }">
                                    {{ $t('navigation.home') }}
                                </router-link>
                            </li>
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle dropdown-color navbar-text-color" href="#"
                                    id="navbarDropdown1" role="button" data-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false"> {{ $t('navigation.charters') }} </a>
                                <div class="dropdown-menu drop-down-content">
                                    <ul class="list-unstyled drop-down-pages">
                                        <li class="nav-item">
                                            <router-link class="dropdown-item nav-link"
                                                :to="{ name: localizedRouteName('LightTackle') }">{{
                                                    $t('navigation.lightTackle') }}</router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link class="dropdown-item nav-link"
                                                :to="{ name: localizedRouteName('BottomFishing') }">{{
                                                    $t('navigation.bottomFishing') }}</router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link class="dropdown-item nav-link"
                                                :to="{ name: localizedRouteName('AmberjackFishing') }">{{
                                                    $t('navigation.amberjackFishing') }}</router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link class="dropdown-item nav-link"
                                                :to="{ name: localizedRouteName('DentexFishing') }">{{
                                                    $t('navigation.dentexFishing') }}</router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link class="dropdown-item nav-link"
                                                :to="{ name: localizedRouteName('GiantBluefinTuna') }">{{
                                                    $t('navigation.giantBluefin') }}</router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link class="dropdown-item nav-link"
                                                :to="{ name: localizedRouteName('DeepSeaTrolling') }">{{
                                                    $t('navigation.deepSeaTrolling') }}</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li class="nav-item" :class="{ active: $route.name === localizedRouteName('PrivateBoat') }">
                                <router-link class="nav-link" :to="{ name: localizedRouteName('PrivateBoat') }">
                                    {{ $t('navigation.privateBoat') }}
                                </router-link>
                            </li>
                            <li class="nav-item" :class="{ active: $route.name === localizedRouteName('Contact') }">
                                <router-link class="nav-link" :to="{ name: localizedRouteName('Contact') }">
                                    {{ $t('navigation.contact') }}
                                </router-link>
                            </li>

                            <!-- Elements mòbils (només visibles en el menú mòbil) -->
                            <li class="mobile-menu-items">
                                <div class="mobile-social-links my-3 pl-3">
                                    <a href="https://www.instagram.com/enigma_fishing/" target="_blank"
                                        class="social-icon mr-3">
                                        <i class="fa-brands fa-instagram instagram-icon" aria-hidden="true"></i>
                                    </a>

                                    <div class="d-inline-block language-selector-mobile">
                                        <a href="#" class="lang-item" @click.prevent="changeLanguage('es')"
                                            :class="{ 'active': currentLanguage === 'es' }">
                                            <span>ESP</span>
                                        </a>
                                        <span class="separator">|</span>
                                        <a href="#" class="lang-item" @click.prevent="changeLanguage('en')"
                                            :class="{ 'active': currentLanguage === 'en' }">
                                            <span>ENG</span>
                                        </a>
                                    </div>
                                </div>

                                <div class="mobile-phone my-3 pl-3">
                                    <a href="tel:+34667587512" class="text-decoration-none d-flex align-items-center">
                                        <i class="fa-solid fa-phone mr-2"></i>
                                        <span class="number">+34 667 587 512</span>
                                    </a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </nav>
                <div class="last_list">
                    <!-- Social Media -->
                    <div class="social-media-icon mr-4">
                        <a href="https://www.instagram.com/enigma_fishing/" target="_blank" class="social-icon">
                            <i class="fa-brands fa-instagram instagram-icon" aria-hidden="true"></i>
                        </a>
                    </div>

                    <!-- Language selector -->
                    <div class="language-selector dropdown">
                        <a href="#" class="dropdown-toggle text-decoration-none" data-toggle="dropdown"
                            aria-expanded="false">
                            <i class="fa-solid fa-globe language-icon"></i>
                            <span class="language-code">{{ currentLanguage.toUpperCase() }}</span>
                        </a>
                        <div class="dropdown-menu">
                            <a href="#" class="dropdown-item" @click.prevent="changeLanguage('es')"
                                :class="{ 'active': currentLanguage === 'es' }">
                                <span class="flag-icon">ESP</span> {{ $t('common.languages.spanish') }}
                            </a>
                            <a href="#" class="dropdown-item" @click.prevent="changeLanguage('en')"
                                :class="{ 'active': currentLanguage === 'en' }">
                                <span class="flag-icon">ENG</span> {{ $t('common.languages.english') }}
                            </a>
                        </div>
                    </div>

                    <a href="tel:+34667587512" class="text-decoration-none">
                        <div class="phone-number">
                            <figure class="banner-phoneicon mb-0">
                                <img src="/theme/seaquest/assets/images/banner-phoneicon.png" alt="image"
                                    class="img-fluid">
                            </figure>
                            <span class="number">+34 667 587 512</span>
                        </div>
                    </a>
                </div>
            </div>
        </header>
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import { watch, getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router';
import { useRouteLocalization } from '@/composables/useRouteLocalization'

export default {
    name: 'Navbar',
    setup() {
        const { t, locale } = useI18n()
        const { localizedRouteName } = useRouteLocalization()
        const router = useRouter();
        const { appContext } = getCurrentInstance()

        watch(locale, newLocale => {
            appContext.config.globalProperties.$setKlaroLang(newLocale)
        })

        const changeLanguage = (lang) => {
            if (locale.value === lang) {
                return;
            }

            locale.value = lang;

            const currentRoute = router.currentRoute.value;
            const currentName = currentRoute.name || '';

            if (!currentName || currentName === 'NotFound') {
                router.push({ name: localizedRouteName('Home') });
                return;
            }

            const baseName = currentName.replace(/(ES|EN)$/, '');

            const newRouteName = localizedRouteName(baseName);

            if (newRouteName !== currentName) {
                router.push({ name: newRouteName });
            }
        };

        return {
            t,
            changeLanguage,
            currentLanguage: locale,
            localizedRouteName
        }
    },
}
</script>

<style scoped>
.social-media-icon {
    margin-right: 15px;
    display: inline-block;
}

.social-media-icon .social-icon {
    display: flex;
    align-items: center;
    transition: all 0.3s ease-in-out;
}

/* Estil específic per a la icona d'Instagram */
.instagram-icon {
    font-size: 22px;
    line-height: 22px;
    color: var(--e-global-color-nav-text, #000) !important;
    transition: all 0.3s ease-in-out;
}

/* Estil hover similar al selector d'idioma */
.social-media-icon .social-icon:hover .instagram-icon {
    color: var(--e-global-color-accent) !important;
}

.language-selector {
    margin-right: 30px;
    display: inline-block;
}

.language-selector .dropdown-toggle {
    color: #000;
    font-size: 16px;
    display: flex;
    align-items: center;
    transition: all 0.3s ease-in-out;
}

.language-selector .dropdown-toggle:hover {
    color: var(--e-global-color-accent);
}

.language-selector .language-icon {
    font-size: 20px;
    line-height: 20px;
    color: var(--e-global-color-nav-text) !important;
    transition: all 0.3s ease-in-out;
}

.language-selector:hover .language-icon {
    color: var(--e-global-color-accent) !important;
}

.language-selector .language-code {
    margin-left: 5px;
    font-size: 18px;
    line-height: 18px;
    font-weight: 500;
    text-transform: uppercase;
    color: var(--e-global-color-nav-text) !important;
    transition: all 0.3s ease-in-out;
}

.language-selector:hover .language-code {
    color: var(--e-global-color-accent) !important;
}

.language-selector .dropdown-menu {
    min-width: 160px;
    padding: 10px 0;
    border-radius: 4px;
    border: none;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.language-selector .dropdown-item {
    padding: 8px 15px;
    color: #333;
    transition: all 0.3s;
}

.language-selector .dropdown-item:hover,
.language-selector .dropdown-item.active {
    background-color: var(--e-global-color-accent);
    color: #fff;
}

.language-selector .flag-icon {
    font-weight: bold;
    margin-right: 8px;
}

.last_list {
    display: flex;
    align-items: center;
}

/* Alineació vertical del contingut */
.social-media-icon,
.language-selector {
    display: flex;
    align-items: center;
}

/* Estil per als elements del menú mòbil */
.mobile-menu-items {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    margin-top: 10px;
    padding-top: 10px;
    display: none;
    /* Amagat per defecte */
}

.language-selector-mobile {
    font-size: 16px;
    font-weight: 500;
}

.language-selector-mobile .lang-item {
    color: var(--e-global-color-nav-text, #000);
    text-decoration: none;
    padding: 0 5px;
    transition: color 0.3s ease-in-out;
}

.language-selector-mobile .lang-item:hover,
.language-selector-mobile .lang-item.active {
    color: var(--e-global-color-accent);
}

.language-selector-mobile .separator {
    color: rgba(0, 0, 0, 0.4);
}

.mobile-phone a {
    color: #000 !important;
}

.mobile-phone .number {
    color: #000 !important;
    font-size: 16px;
    font-weight: 500;
}

.mobile-social-links .instagram-icon {
    font-size: 20px;
}

/* Media query per a dispositius amb pantalla menor a 992px (menú hamburguesa) */
@media (max-width: 991.98px) {

    /* Amagar els elements originals en versió mòbil */
    .last_list {
        display: none !important;
    }

    /* Mostrar els elements del menú mòbil */
    .mobile-menu-items {
        display: block !important;
    }

    .mobile-social-links {
        display: flex;
        align-items: center;
    }
}

@media (max-width: 767px) {
    .language-selector {
        margin-right: 15px;
    }

    .social-media-icon {
        margin-right: 10px;
    }
}
</style>